import {atom} from "recoil";
import {FormSearchOWLocationGroupLocationModel, OWLocationGroupLocations} from "../api/types/owLocationGroupLocation";

export const selectedOWLocationGroupLocationAtom = atom<OWLocationGroupLocations | null>({
    key: "selectedOWLocationGroupLocationAtom",
    default: null
});

export const defaultSearchedOWLocationGroupLocation = {owLocationGroupName: "", locationName: "", legalEntities: []};
export const searchedOWLocationGroupLocationAtom = atom<FormSearchOWLocationGroupLocationModel>({
    key: "searchedOWLocationGroupLocationAtom",
    default: defaultSearchedOWLocationGroupLocation
});